module.exports = __webpack_public_path__ + "img/gestion.2c7fdce3.svg";